export default {
  h1_services: "Сервисы искусственного интеллекта для врачей",
  Services: "Сервисы",
  eduServices: "Курсы",
  AIServices: "Сервисы",
  mg: "Маммография",
  dx: "Рентгенография ОГК \n и флюорография",
  // rf: "Рентгенограммы",
  "Go to service": "Перейти",
  "Service banner text":
    "Рассчитайте эффект от внедрения искусственного интеллекта в ваше учреждение",
  Calc: "Рассчитать",
  "Services title": "Список сервисов | " + process.env.VUE_APP_INSTALL_NAME,
  "No description service": "Описание не задано",
  "Services cannot loading": "Сервис временно недоступен. Попробуйте позже",
  "Cash calc title": "Расчет экономии | " + process.env.VUE_APP_INSTALL_NAME,
  "Cash calc": "Расчет экономии",
  "Cash calc desc": "Сколько ресурсов вы сможете сэкономить с ИИ",
  "Cash calc desc about":
    "Введите данные для вашего учреждения. После выхода из калькулятора данные удалятся.",
  "Average cash": "Средняя заработная плата врача-рентгенолога в месяц",
  "Study calc count": "Количество исследований в вашем учреждении в месяц",
  mmg: "Маммография",
  ddx: "Рентгенография ОГК",
  ct: "КТ ОГК",
  "Start calc": "Рассчитать",
  economy: "Экономия",
  rub: " руб.",
  "calc time": " ч",
  "Calc summary": "Итого в год",
  "Without AI": "Без искусственного интеллекта",
  "With AI": "С искусственным интеллектом",
  "Count calc short": "Кол-во ",
  "Calc in Year": " в год",
  "Calc item 1": "Описание <br /> 1 исследования, мин",
  "Calc item 2": "Стоимость описания <br />1 исследования, руб",
  "Calc item 3": "Затраты на <br />описание",
  "Calc item 4": "Время на <br />описание, ч",
  mmg__count: "ММГ",
  ddx__count: "РГ/ФЛГ",
  ct__count: "КТ",
  "Calc info": "Методология расчета",
};
